<template>

  <v-card class="rounded-xl card-bg card-hd pt-4 px-4 pb-4 point-table-card" variant="elevated" elevation="0">
    <div class="d-flex justify-space-between align-center">
      <v-form inline>
        <div class="search-item mr-4">
          <span class="search-label">{{ $str.getKey('设备型号/设备型号') }}</span>
          <v-text-field v-model.trim="queryForm.equipmentModel" maxlength="20" placeholder="请输入" variant="outlined"
            density="compact" hide-details rounded="xl" class="search-input" style="width: 200px;"
            @keyup.enter="handleQuery" />
        </div>
      </v-form>
      <div class="search-actions d-flex ga-3">
        <v-btn color="#2655f1" rounded="xl" @click="handleQuery">
          <v-icon start icon="mdi-magnify" />
          {{ $str.getKey('全局/查询') }}
        </v-btn>
        <v-btn variant="outlined" color="#2655f1" rounded="xl" @click="handleReset">
          <v-icon start icon="mdi-refresh" />
          {{ $str.getKey('全局/重置') }}
        </v-btn>
        <v-btn color="#2655f1" rounded="xl" @click="handleAdd">
          <v-icon start icon="mdi-plus" />
          {{ $str.getKey('全局/新增') }}
        </v-btn>
      </div>
    </div>
  </v-card>

  <v-card class="rounded-xl card-bg card-bd mt-4 point-table-card point-table-body" variant="elevated" elevation="0" :loading="listLoading">
    <div class="px-4 py-3 d-flex justify-space-between align-center">
      <div class="text-subtitle-1 font-weight-medium"></div>
    </div>

    <div class="table-wrapper flex-grow-1 overflow-hidden d-flex flex-column">
      <v-table fixed-header height="500" style="width: 100%; background: transparent" class="gm-table border-none">
        <thead>
          <tr>
            <th style="width: 80px">ID</th>
            <th style="width: 120px">{{ $str.getKey('设备型号/设备类型') }}</th>
            <th style="width: 120px">{{ $str.getKey('设备型号/设备品牌') }}</th>
            <th style="width: 120px">{{ $str.getKey('设备型号/设备型号') }}</th>
            <th style="width: 120px">{{ $str.getKey('设备型号/数据源') }}</th>
            <th style="width: 120px">{{ $str.getKey('设备型号/数据表') }}</th>
            <th style="width: 100px">{{ $str.getKey('设备型号/版本号') }}</th>
            <th style="width: 100px">{{ $str.getKey('设备型号/数据间隔') }}</th>
            <th style="width: 100px">{{ $str.getKey('设备型号/保存方式') }}</th>
            <th style="width: 120px">{{ $str.getKey('设备型号/数据上传方式') }}</th>
            <th style="width: 150px">{{ $str.getKey('设备型号/数据模板') }}</th>
            <th style="width: 340px" class="text-center">{{ $str.getKey('全局/操作') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in modelList" :key="row.id">
            <td class="text-medium-emphasis">{{ row.id }}</td>
            <td>{{ fmtDeviceType(row) }}</td>
            <td>{{ fmt(row.equipmentBrand) }}</td>
            <td><span style="color: orange;">{{ row.equipmentModel }}</span></td>
            <td>{{ row.dataSource }}</td>
            <td>{{ row.tableName }}</td>
            <td>{{ row.version }}</td>
            <td>{{ row.interval }}</td>
            <td>{{ row.saveMode }}</td>
            <td>{{ row.uploadMethod }}</td>
            <td>{{ row.contentTemplate }}</td>
            <td>
              <div class="d-flex justify-center ga-2">
                <v-btn variant="text" color="#2655f1" rounded="xl" @click="handleEdit(row)">{{ $str.getKey('全局/编辑') }}</v-btn>
                <v-btn variant="text" color="#2655f1" rounded="xl" @click="handleEditPoint(row)">{{ $str.getKey('设备型号/修改点表') }}</v-btn>
                <v-btn variant="text" color="#2655f1" rounded="xl" @click="handleRefreshCache(row)">{{ $str.getKey('设备型号/刷新缓存') }}</v-btn>
                <v-btn variant="text" color="#FF6A46" rounded="xl" @click="handleDelete(row)">{{ $str.getKey('全局/删除') }}</v-btn>
              </div>
            </td>
          </tr>
        </tbody>
      </v-table>
    </div>

    <div v-if="modelList.length === 0" class="text-center py-12 text-medium-emphasis">
      暂无数据
    </div>

    <div class="px-6 py-4 d-flex justify-end">
      <TablePagination :total="total" :pageSize="queryParams.pageSize" v-model="queryParams.pageNum"
        @change="fetchModelList" />
    </div>
  </v-card>


  <v-dialog v-model="editModelVisible" max-width="740px" persistent class="gm-dialog">
    <v-card class="rounded-30 overflow-hidden dialog-card">
      <div class="gm-dialog-header d-flex align-center px-8 py-6">
        <div class="text-h5">
          <span style="color: #2655F1;">{{ dialogTitle.substring(0, 2) }}</span>
          <span>{{ dialogTitle.substring(2) }}</span>
        </div>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="handleCancelModel" />
      </div>
      <v-card-text class="pa-8 pt-4 pb-2 overflow-auto">
        <v-form ref="formRef" v-model="formValid" :disabled="loading">
          <div class="form-grid-2">
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/设备类型') }}</label>
              <v-text-field v-model="form.deviceType" :placeholder="$str.getKey('设备型号/设备类型')" variant="outlined"
                density="compact" hide-details class="gm-input"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/设备品牌') }}</label>
              <v-text-field v-model="form.equipmentBrand" :placeholder="$str.getKey('设备型号/设备品牌')" variant="outlined"
                density="compact" hide-details class="gm-input"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/设备型号') }}</label>
              <v-text-field v-model="form.equipmentModel" :placeholder="$str.getKey('设备型号/设备型号')" variant="outlined"
                density="compact" hide-details class="gm-input" :rules="rules.equipmentModel"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/数据源') }}</label>
              <v-text-field v-model="form.dataSource" :placeholder="$str.getKey('设备型号/数据源')" variant="outlined"
                density="compact" hide-details class="gm-input" :rules="rules.dataSource"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/数据表') }}</label>
              <v-text-field v-model="form.tableName" :placeholder="$str.getKey('设备型号/数据表')" variant="outlined"
                density="compact" hide-details class="gm-input" :rules="rules.tableName"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/版本号') }}</label>
              <v-text-field v-model="form.version" :placeholder="$str.getKey('设备型号/版本号')" variant="outlined"
                density="compact" hide-details class="gm-input" :rules="rules.version"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/数据间隔') }}</label>
              <v-text-field v-model="form.interval" :placeholder="$str.getKey('设备型号/数据间隔')" variant="outlined"
                density="compact" hide-details class="gm-input"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/保存方式') }}</label>
              <v-text-field v-model="form.saveMode" :placeholder="$str.getKey('设备型号/保存方式')" variant="outlined"
                density="compact" hide-details class="gm-input"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/数据上传方式') }}</label>
              <v-text-field v-model="form.uploadMethod" :placeholder="$str.getKey('设备型号/数据上传方式')" variant="outlined"
                density="compact" hide-details class="gm-input"></v-text-field>
            </div>
            <div class="form-group">
              <label>{{ $str.getKey('设备型号/数据模板') }}</label>
              <v-text-field v-model="form.contentTemplate" :placeholder="$str.getKey('设备型号/数据模板')" variant="outlined"
                density="compact" hide-details class="gm-input"></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-8 pb-8 pt-0 justify-end">
        <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4"
          @click="handleCancelModel">{{ $str.getKey('全局/取消') }}</v-btn>
        <v-btn color="#2655F1" variant="flat" class="gm-btn-primary px-10 text-white" :loading="loading"
          @click="handleSaveModel(formRef)">{{ $str.getKey('全局/保存') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- 删除确认弹窗 -->
  <v-dialog v-model="deleteDialogVisible" max-width="420px" persistent class="gm-dialog">
    <v-card class="rounded-30 overflow-hidden dialog-card">
      <div class="gm-dialog-header d-flex align-center px-8 py-6">
        <div class="text-h5">
          <span style="color: #2655F1">删除</span><span>确认</span>
        </div>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="closeDeleteDialog" />
      </div>
      <v-card-text class="pa-8 pt-2 pb-4">
        <div class="text-body-1">
          确认删除「{{ deleteTargetName }}」吗？
        </div>
      </v-card-text>
      <v-card-actions class="px-8 pb-8 pt-0 justify-end">
        <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4"
          @click="closeDeleteDialog">{{ $str.getKey('全局/取消') }}</v-btn>
        <v-btn color="#2655F1" variant="flat" class="gm-btn-primary px-10 text-white" :loading="deleteLoading"
          @click="confirmDelete">{{ $str.getKey('全局/确定') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- </v-card> -->
</template>



<script setup>
import { getModelList, deleteModel, modifyModel, insertModel, refreshCache } from '@/api/device/model';
// import { cusConfirm } from '@/utils';
import { reactive, ref, computed } from 'vue';
import { useRouter } from 'vue-router';
// import { ElMessage } from 'element-plus';
import TablePagination from '@/components/TablePagination/index.vue';
import { eui } from 'ems-ui';

const $str = window.$str
const router = useRouter()
const listLoading = ref(false)
const modelList = ref([])
const total = ref(0)
const editModelVisible = ref(false)
const formRef = ref(null)
const formValid = ref(false)
const loading = ref(false)
const deleteDialogVisible = ref(false)
const deleteTargetRow = ref(null)
const deleteLoading = ref(false)
const deleteTargetName = computed(() => {
  const row = deleteTargetRow.value
  if (!row) return ''
  return row.equipmentModel || row.equipmentBrand || row.tableName || ''
})

const queryForm = reactive({
  equipmentModel: '',
})

const queryParams = reactive({
  pageNum: 1,
  pageSize: 10,
})

const form = reactive({
  modelName: '',
  modelType: '',
  modelDescription: '',
  modelStatus: '',
  modelCreateTime: '',
  deviceType: '',
  equipmentBrand: '',
  id: '',
  dataSource: '',
  tableName: '',
  version: '',
  interval: '',
  saveMode: '',
  uploadMethod: '',
  contentTemplate: '',
})

const rules = computed(() => ({
  equipmentModel: [v => !!v || $str.getKey('设备型号/请输入设备型号')],
  dataSource: [v => !!v || $str.getKey('设备型号/请输入数据源')],
  tableName: [v => !!v || $str.getKey('设备型号/请输入数据表')],
  version: [v => !!v || $str.getKey('设备型号/请输入版本号')],
}))

const dialogTitle = computed(() => {
  return form.id ? $str.getKey('设备型号/编辑设备型号') : $str.getKey('设备型号/新增设备型号')
})

function handleQuery() {
  fetchModelList()
}

function handleReset() {
  resetForm()
  fetchModelList()
}

async function fetchModelList() {
  listLoading.value = true
  try {
    const postParams = Object.assign({}, queryParams, {
      equipmentModel: queryForm.equipmentModel,
    })
    const res = await getModelList(postParams)
    console.log('res', res)
    modelList.value = res.rows
    total.value = res.total
    // listLoading.value = false
  } catch (error) {
    console.warn(error)
  } finally {
    listLoading.value = false
  }
}
fetchModelList()

function handleEdit(row) {
  console.log('row', row)
  resetForm()
  Object.assign(form, row)
  editModelVisible.value = true
}

function handleEditPoint(row) {
  router.push({
    query: {
      subTab: 'point-table',
      modelId: row.id,
    }
  })
}

function handleAdd() {
  resetForm()
  editModelVisible.value = true
}

async function handleRefreshCache(row) {
  console.log('row', row)
  const r = await refreshCache(row.id)
  if (r.code == 200) {
    // ElMessage.success(r.msg)
    eui.showToast(r.msg, 'success')
    fetchModelList()
  }
}

async function handleDelete(row) {
  deleteTargetRow.value = row
  deleteDialogVisible.value = true
}

function closeDeleteDialog() {
  if (deleteLoading.value) return
  deleteDialogVisible.value = false
  deleteTargetRow.value = null
}

async function confirmDelete() {
  if (!deleteTargetRow.value?.id) return
  deleteLoading.value = true
  try {
    const r = await deleteModel(deleteTargetRow.value.id)
    if (r.code == 200) {
      eui.showToast('删除成功', 'success')
      deleteDialogVisible.value = false
      deleteTargetRow.value = null
      fetchModelList()
    }
  } finally {
    deleteLoading.value = false
  }
}

function resetForm() {
  queryForm.equipmentModel = ''
  queryParams.pageNum = 1
  queryParams.pageSize = 10

  form.equipmentModel = ''
  form.dataSource = ''
  form.tableName = ''
  form.version = ''
  form.interval = ''
  form.saveMode = ''
  form.uploadMethod = ''
  form.contentTemplate = ''
  form.deviceType = ''
  form.equipmentBrand = ''
  form.id = ''
}

function handleCancelModel() {
  editModelVisible.value = false
}

async function handleSaveModel(formRef) {
  const { valid } = await formRef.value.validate()
  if (!valid) {
    return
  }

  const fn = form.id ? modifyModel : insertModel

  try {
    loading.value = true
    const r = await fn(form)
    if (r.code == 200) {
      // ElMessage.success($str.getKey('设备型号/操作成功'))
      eui.showToast('操作成功', 'success')
      fetchModelList()
      editModelVisible.value = false
    }
  } catch (error) {
    console.warn(error)
  } finally {
    loading.value = false
  }
}

function fmt(value) {
  return value ? value : '--'
}

function fmtDeviceType(row) {
  const value = row.deviceType
  if (value == '1') {
    return $str.getKey('设备型号/光伏')
  } else if (value == '2') {
    return $str.getKey('设备型号/充电桩')
  }
  return '--'
}
</script>

<style scoped lang="scss">
.search-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-label {
  font-size: 14px;
  color: rgba(var(--v-theme-on-surface), 0.6);
  white-space: nowrap;
}

.card-hd {
  border-radius: 0 0 30px 30px !important;
}

.card-bd {
  border-radius: 30px !important;
}

.point-table-card {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.point-table-body {
  min-height: 0;
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  overflow: hidden;
  padding: 0 16px;
}

.table-wrapper {
  min-width: 0;
  max-width: 100%;
}

.gm-table {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;

  :deep(.v-table__wrapper) {
    overflow-x: auto !important;
  }

  :deep(table) {
    min-width: 1400px;
  }

  :deep(thead tr) {
    background: #f8fafc !important;
  }

  :deep(th) {
    font-weight: 600 !important;
    color: rgba(0, 0, 0, 0.8) !important;
    border: none !important;
    background: #f8fafc !important;
    height: 56px !important;
    padding: 0 24px !important;
    white-space: nowrap;
  }

  :deep(td) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.04) !important;
    height: 56px !important;
    padding: 0 24px !important;
    white-space: nowrap;
  }

  :deep(th:last-child),
  :deep(td:last-child) {
    position: sticky;
    right: 0;
    box-shadow: -8px 0 12px rgba(15, 23, 42, 0.06);
  }

  :deep(th) {
    z-index: 5 !important;
  }

  :deep(th:last-child) {
    z-index: 6 !important;
    background: #f8fafc !important;
  }

  :deep(td:last-child) {
    z-index: 1;
    background: #fff !important;
  }
}
.gm-dialog {
  :deep(.v-overlay__content) {
    border-radius: 30px !important;
  }
}

.dialog-card {
  border-radius: 30px !important;
  background: #fff;
}

.gm-dialog-header {
  background: linear-gradient(185deg, #2655f160 0%, #fff0 60%);
  position: relative;

  .text-h5 {
    font-size: 24px !important;
    letter-spacing: 0.5px;
    font-weight: 500;
  }
}

.form-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 10px;

  label {
    font-size: 14px;
    font-weight: 500;
    color: #2E2E2E;
  }
}

.gm-input {
  :deep(.v-field) {
    background-color: rgba(239, 244, 251, 0.7) !important;
    border-radius: 15px !important;
    box-shadow: none !important;
    padding-inline: 4px !important;

    .v-field__outline {
      display: none !important;
    }

    input,
    .v-select__selection {
      font-size: 14px;
      color: rgba(46, 46, 46, 0.8);
      font-weight: 400;
    }
  }
}

.gm-btn-secondary {
  height: 42px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #545454 !important;
  box-shadow: none !important;
}

.gm-btn-primary {
  height: 42px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  box-shadow: none !important;
}
</style>
